import { Component } from '@angular/core';

@Component({
  selector: 'app-hthpfluidloss-vertical-header',
  standalone: false,
  templateUrl: './hthpfluidloss-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class HthpfluidlossVerticalHeaderComponent  {
 
}
